// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"47cd5312","261":"e579fd8a","453":"4c3ab347","787":"02af6488","950":"192421b6"}[chunkId] + ".chunk.js";
};